import React, { useState, useContext, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import MaterialTable, { MTableToolbar } from 'material-table';
import { TextField, Button, Snackbar, Typography, RadioGroup, FormControlLabel, Radio, OutlinedInput, MenuItem, FormControl, ListItemText, Select, Checkbox } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardDateTimePicker } from '@material-ui/pickers';
import { Typeahead } from 'react-bootstrap-typeahead';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MuiAlert from '@material-ui/lab/Alert';
import AddIcon from '@material-ui/icons/Add';
import 'date-fns';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone, GetTimeZoneOffset } from '../header/timeFormatter';
import { HttpService } from '../../apiAuthorization/httpService';
import { GlobalTheme } from '../../layouts/theme';
import { Context } from '../contexts/siteContext.js';
import { Theme } from '../contexts/themeContext.js';
import { TransactionTime } from '../common/transactionTime';
import InactiveTimeout from '../common/inactiveTimeout';
import TimerDialog from "../common/timerDialog";
import Grid from '@material-ui/core/Grid';
import AlertDialog from '../alertDialog/alertDialog.js'
import ContentDialog from '../common/contentDialog.js'
import EscalationList from './escalationList.js'
import ClinicalNoteList from './clinicalNoteList.js'
import PatientFellAdd from './patientFellAdd.js'
import SignHandOffAdd from './signHandOffAdd.js'
import ContactAdd from './contactAdd.js'
import EnvironmentalChecklistAdd from './environmentalChecklistAdd.js'
import ObservationLogAdd from './observationLogAdd.js'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import EditIcon from '@material-ui/icons/Edit';
import AttendantCheckList from './attendantChecklist.js';
import FoodTrayChecklist from './foodTrayChecklist.js'
import TransferLocationAdd from './transferLocationAdd.js'
import RestraintCheckList from './restraintCheckList.js'
import RestraintCheckListHistory from './restraintCheckListHistory.js'
import PatientStatusAdd from './patientStatusAdd';
import FullScreenDialog from '../common/fullScreenDialog.js';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '20px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    newButton: {
        color: "#64748B",
        borderColor: "#64748B",
        fontWeight: "600"
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    notAllowed: {
        cursor: 'not-allowed'
    },
    restraintButtonGroup: {
        float: 'left',
        display: 'flex',
        justifyItems: 'center',
        alignItems: 'center'
    }
}));

const PatientSittingAdd = forwardRef((props, ref) => {
    const classes = useStyles();
    const { locations, patientSittings, showObservation, isManager, attendants, trainingMode } = props;
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [showInactiveMessage, setShowInactiveMessage] = useState(false);
    const [reflect] = useState(false);
    const [backDrop, setBackDrop] = useState(true);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [modified, setModified] = useState(false);
    const [action, setAction] = useState('New');

    const [openDialog, setOpenDialog] = useState(false);
    const [openRestraintDialog, setOpenRestraintDialog] = useState(false);

    const [messageDialog] = useState("Currently Attendant already has an active observation. Are you sure you want to create another one?");
    const [messageRestraintDialog] = useState("Are you sure you want to restraint start?");
    const [allRisks, setAllRisks] = useState([]);
    const [risksDDL, setRisksDDL] = useState([]);
    const [currentRiskClassifications, setCurrentRiskClassifications] = useState([]);
    const [classificationsSelected, setClassificationsSelected] = useState([]);
    const [observationReasons, setObservationReasons] = useState([]);
    const [selectedObservationReasons, setSelectedObservationReasons] = useState([]);
    const [attendantSelected, setAttendantSelected] = useState({ FirstName: "", LastName: "" });
    const [isShowSignHandOff, setIsShowSignHandOff] = useState(false);
    const [isShowPatientFell, setIsShowPatientFell] = useState(false);
    const [isShowAttendantCheckList, setIsShowAttendantCheckList] = useState(false);
    const [isShowContact, setIsShowContact] = useState(false);
    const [disableWithAttendantCheckList, setDisableWithAttendantCheckList] = useState(true);
    const [collapse, setCollapse] = useState(false);
    const [isShowEnvironmentalChecklist, setIsShowEnvironmentalChecklist] = useState(false);
    const [isShowObservationLogAdd, setIsShowObservationLogAdd] = useState(false);
    const [isShowClinicalNotes, setIsShowClinicalNotes] = useState(false);
    const [observationTemplateBase, setObservationTemplateBase] = useState([]);
    const [interventionTemplateBase, setInterventionTemplateBase] = useState([]);
    const [safetyCheckTemplateBase, setSafetyCheckTemplateBase] = useState([]);
    const [locationCodeTemplateBase, setLocationCodeTemplateBase] = useState([]);
    const [observationOptions, setObservationOptions] = useState([]);
    const [interventionOptions, setInterventionOptions] = useState([]);
    const [safetyCheckOptions, setSafetyCheckOptions] = useState([]);
    const [locationCodeOptions, setLocationCodeOptions] = useState([]);
    const [hideSignHandOffConfirm, setHideSignHandOffConfirm] = useState(false);
    const [observationLogDto, setObservationLogDto] = useState([]);
    const [isShowManagerComments, setIsShowManagerComments] = useState(false);
    const [disableWithStyle, setDisableWithStyle] = useState(true);
    const [hidePatientFellConfirm, setHidePatientFellConfirm] = useState(true);
    const [isShowClinicalObservation, setIsShowClinicalObservation] = useState(false);
    const [patientObservationAttendantDto, setPatientObservationAttendantDto] = useState({});
    const [isShowFoodTrayChecklist, setIsShowFoodTrayChecklist] = useState(false);
    const [isShowRestraintCheckList, setIsShowRestraintCheckList] = useState(false);
    const [isShowRestraintCheckListHistory, setIsShowRestraintCheckListHistory] = useState(false);
    const [isShowTransferLocation, setIsShowTransferLocation] = useState(false);
    const [canRestraint, setCanRestraint] = useState(false);
    const [hideTransferLocationConfirm, setHideTransferLocationConfirm] = useState(false);
    const [clinicalNotes, setClinicalNotes] = useState("");
    const [remainingTime, setRemainingTime] = useState(0);
    const [timerOpen, setTimerOpen] = useState(false);
    const [patientStatusOpen, setPatientStatusOpen] = useState(false);
    const [callback, setCallback] = useState({
        func: null
    });
    const [restraintCheckListItemBase] = useState({
        Id: 0,
        AppPatientSittingId: 0,
        StartTime: null,
        EndTime: null,
        RestraintTypes: null,
        RestraintTypesArr: [],
        Started: false,
        StartTimeString: null
    });
    const [restraintCheckListItem, setRestraintCheckListItem] = useState({});
    const signHandOffRef = useRef();
    const observationLogRef = useRef();
    const environmentalChecklistRef = useRef();
    const patientFellRef = useRef();
    const contactRef = useRef();
    const attendantCheckListRef = useRef();
    const foodTrayChecklistRef = useRef();
    const locationTransfertRef = useRef();
    const restraintCheckListRef = useRef();
    const patientStatusRef = useRef();
    const posGroupId = defaultSite.IntegratedSystem.POSGroupId;
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    const rowStyle = (rowData, rowIndex) => {
        return {
            border: '2px solid',
            borderColor: (rowData.Flag || rowData.Lock) ? 'red' : "",
            color: (rowData.Flag || rowData.Lock) ? 'red' : 'black',
            cursor: (rowData.Disabled || rowData.Lock) ? 'not-allowed' : 'pointer',
            pointerEvents: 'all !important'
        };
    };

    const [observationLogPageCount] = useState(100);
    const [isShowEscalations, setIsShowEscalations] = useState(false);

    const [escalationList, setEscalationList] = useState({
        columns: [
            { field: 'ObservationTimeString', title: 'Time' },
            { field: 'Observer', title: 'Observer' },
            { field: 'ObservationText', title: 'Observation', width: (posGroupId === 1) ? '25%' : '40%' },
            { field: 'InterventionText', title: 'Intervention', width: (posGroupId === 1) ? '25%' : '0%', hidden: (posGroupId === 2) },
            { field: 'LocationText', title: 'Location', width: (posGroupId === 1) ? '0%' : '20%', hidden: (posGroupId === 1) },
            { field: 'Comments', title: 'Comment', width: '10%', hidden: (posGroupId === 2) }
        ],
        data: [],
        count: 0
    });

    let columns = [];
    if (posGroupId === 1) {
        columns = [
            { field: 'ObservationTimeString', title: 'Time' },
            { field: 'SafetyCheckText', title: 'Safety Check' },
            { field: 'Observer', title: 'Observer' },
            { field: 'ObservationText', title: 'Observation', width: '25%' },
            { field: 'InterventionText', title: 'Intervention', width: '25%' },
            { field: 'Comments', title: 'Comment', width: '10%' }
        ]
    }
    else {
        columns = [
            { field: 'ObservationTimeString', title: 'Time' },
            { field: 'Observer', title: 'Observer' },
            { field: 'ObservationText', title: 'Observation', width: '40%' },
            { field: 'LocationText', title: 'Location', width: '20%' },
        ]
    }
    const [observationLogs, setObservationLogs] = useState({
        columns: columns,
        data: []
    });

    const [clinicalNoteList, setClinicalNoteList] = useState({
        columns: [
            { field: 'ReplacementAttendant', title: 'Name' },
            { field: 'OnlyTimeSignedOffString', title: 'Observation from' },
            { field: 'OnlyTimePickedUpString', title: 'Observation to' },
            { field: 'ClinicalNotes', title: 'Notes' },
        ],
        data: []
    });

    const [restraintCheckListHistoryItem, setRestraintCheckListHistoryItem] = useState({
        columns: [
            { field: 'StartTimeString', title: 'Start Time' },
            { field: 'EndTimeString', title: 'End Time' },
            { field: 'SelectedRestraintTypes', title: 'Type(s) of Restraints' },
        ],
        data: []
    });

    const [requestTypeDDL] = useState([
        { Name: "Scheduled" },
        { Name: "Demand" }
    ]);

    const [patientTypeDDL] = useState([
        { Name: "Inpatient" },
        { Name: "ED" }
    ]);

    const [patientTypeInspiraDDL] = useState([
        { Name: "Close Observation" },
        { Name: "1:1" }
    ]);

    const [isolationPatientDDL] = useState([
        { Name: "Yes" },
        { Name: "No" }
    ]);

    useImperativeHandle(ref, () => {
        return {
            //save: modified ? savePatientSitting : props.parentCallback
            save: savePatientSitting
            , valueChanged: valueChanged
        };
    });

    const valueChanged = () => {
        setModified(true);
        props.inputValueChanged();
    }

    const cancel = () => {
        props.parentCallback();
    }

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const [patientSittingDto, setPatientSittingDto] = useState(props.patientSittingSelected ? props.patientSittingSelected :
        {
            Id: 0,
            SiteId: defaultSite.id,
            TimeZoneOffset: GetTimeZoneOffset(defaultSite),
            StartDate: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite),
            EndDate: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", 24, defaultSite),
            RequestDate: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite),
            TrainingMode: trainingMode,
            Requestor: "",
            RequestType: "",
            PatientType: "",
            IsolationPatient: "",
            Attendant: "",
            AttendantUsername: "",
            RiskClassificationId: "",
            RiskSelected: {},
            LocationId: null,
            LocationPath: null,
            MedicalRecordNumber: null,
            DateBirth: null,
            PatientName: null,
            Bed: null,
            ObservationReasonIds: "",
            PatientDemographic: ""
        });

    const patientSittingDtoDateChanged = (key, date) => {
        date = moment(date).format("MM/DD/YYYY hh:mm a");
        var _PatientSittingDto = { ...patientSittingDto };
        _PatientSittingDto[key] = date;
        setPatientSittingDto(_PatientSittingDto);
    };

    const locationChanged = (e) => {

        setSelectedLocation(e);

        if (e.length > 0) {
            setPatientSittingDto({ ...patientSittingDto, LocationId: e[0]?.GeoLocationId, LocationPath: e[0].GeoLocationBranchName });
        }
        else {
            setPatientSittingDto({ ...patientSittingDto, LocationId: null, LocationPath: null });
        }

    };

    const onAttendantSelected = (event, values, id) => {
        if (values?.AppUserName) {
            var name = (values.FirstName == null ? '' : values.FirstName) + " " + (values.LastName == null ? '' : values.LastName);
            setPatientSittingDto({ ...patientSittingDto, Attendant: name, AttendantUsername: values.AppUserName });
            setAttendantSelected(values);
            setModified(true);
            props.inputValueChanged();
        }

    };

    const onClassificationSelected = (event, values, id) => {
        var idsArr = [];
        for (var index = 0; index < values.length; index++) {
            idsArr.push(values[index].RiskId);
        }

        if (values) {
            setPatientSittingDto({ ...patientSittingDto, RiskClassificationId: idsArr.join() });
            setClassificationsSelected(values);
        }
        setModified(true);
        props.inputValueChanged();
    };

    const onRiskChanged = (event) => {
        setModified(true);
        props.inputValueChanged();
        var selected = allRisks.find(x => x.Risk === event.target.value);
        var _currentRiskClassifications = allRisks.filter(x => x.ParentRiskId !== '0' && checkValIncludes(x.ParentRiskId, selected.RiskId));
        setCurrentRiskClassifications(_currentRiskClassifications);
        setPatientSittingDto({ ...patientSittingDto, Risk: event.target.value, RiskClassificationId: "" });
        setClassificationsSelected([]);
    };

    const onObservationReasonChanged = (event) => {
        const {
            target: { value },
        } = event;

        let selectedReasons = [];

        value.forEach((item) => {
            if (selectedReasons.findIndex((o) => o.Id === item.Id) >= 0) {
                selectedReasons = selectedReasons.filter((x) => x.Id === item.Id);
            } else {
                selectedReasons.push(item);
            }
        });

        let idsArray = [];
        for (let index = 0; index < selectedReasons.length; index++) {
            idsArray.push(selectedReasons[index].Id);
        }

        setPatientSittingDto({ ...patientSittingDto, ObservationReasonIds: idsArray.join() });
        setSelectedObservationReasons(selectedReasons);
    };

    const checkValIncludes = (str, val) => {
        let array = str.split(',');
        if (array.includes(val.toString()))
            return true;
        return false;
    }

    const onRequestTypeChanged = (event) => {
        setModified(true);
        props.inputValueChanged();
        setPatientSittingDto({ ...patientSittingDto, RequestType: event.target.value });
    };

    const onPatientTypeChanged = (event) => {
        setModified(true);
        props.inputValueChanged();
        setPatientSittingDto({ ...patientSittingDto, PatientType: event.target.value });
    };

    const onPatientDemographicChanged = (event) => {
        setModified(true);
        props.inputValueChanged();
        setPatientSittingDto({ ...patientSittingDto, PatientDemographic: event.target.value });
    };
    
    const onIsolationPatientChanged = (event) => {
        setModified(true);
        props.inputValueChanged();
        setPatientSittingDto({ ...patientSittingDto, IsolationPatient: event.target.value });
    };

    const validate = () => {

        if (!patientSittingDto.StartDate) {
            setErrorMessage("Please select a Start Date");
            return false;
        }
        else if (!patientSittingDto.EndDate) {
            setErrorMessage("Please select a End Date");
            return false;
        }
        else if (!moment(patientSittingDto.EndDate).isAfter(patientSittingDto.StartDate)) {
            setErrorMessage("The date of StartDate should be before that of EndDate");
            return false;
        }
        else if (!patientSittingDto.Requestor) {
            setErrorMessage("Please enter the Requestor");
            return false;
        }
        else if (!patientSittingDto.RequestDate) {
            setErrorMessage("Please select a Request Date");
            return false;
        }
        else if (patientSittingDto.RequestDate < patientSittingDto.StartDate && patientSittingDto.RequestDate > patientSittingDto.EndDate) {
            setErrorMessage("The date of Request Date should be between the Start Date and the End Date。");
            return false;
        }
        else if (!patientSittingDto.RequestType) {
            setErrorMessage("Please select a  Request Type");
            return false;
        }
        else if (observationLogs.data.length > 0) {
            if (!patientSittingDto.AttendantUsername) {
                setErrorMessage("Please enter a valid Attendant");
                return false;
            }
        }
        else if (!patientSittingDto.AttendantUsername && patientSittingDto.Attendant !== "" && patientSittingDto.Attendant != null && patientSittingDto.Attendant !== undefined) {
            setErrorMessage("Please enter a valid Attendant");
            return false;
        }
        else if (!patientSittingDto.LocationId) {
            setErrorMessage("Please select a Location");
            return false;
        }
        else if (!patientSittingDto.Bed) {
            setErrorMessage("Please enter an Bed");
            return false;
        }
        else if (!patientSittingDto.PatientName) {
            setErrorMessage("Please enter an PatientName");
            return false;
        }
        else if (!patientSittingDto.DateBirth || !moment(patientSittingDto.DateBirth).isValid()) {
            setErrorMessage("Please enter an DateBirth");
            return false;
        }
        else if (!patientSittingDto.MedicalRecordNumber) {
            setErrorMessage("Please enter an MedicalRecordNumber");
            return false;
        }
        else if (!patientSittingDto.PatientType) {
            setErrorMessage("Please select a Patient Type");
            return false;
        }
        else if (!patientSittingDto.IsolationPatient) {
            setErrorMessage("Please select a Isolation Patient");
            return false;
        }
        if (posGroupId === 1) {
            if (!patientSittingDto.Risk) {
                setErrorMessage("Please select a Risk");
                return false;
            }
            else if (patientSittingDto.RiskClassificationId.length === 0) {
                setErrorMessage("Please select a Risk Classification");
                return false;
            }
        }
        else if (posGroupId === 2) {
            if (!patientSittingDto.ObservationReasonIds) {
                setErrorMessage("Please select a Reason for Observation");
                return false;
            }
        }
        return true;
    };

    const checkAttendantWithMultiple = (dto, callback) => {
        setBackDrop(true);
        setCallback({ ...callback, func: null });
        HttpService.post('/PatientSitting/CheckAttendantWithMultiple', dto)
            .then((result) => {
                setBackDrop(false);
                if (result.data) {
                    dialogOpen();
                    setCallback({ ...callback, func: callback });
                    return;
                }

                if (callback)
                    callback();

            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });

    };

    const dialogConfirm = () => {
        callback.func();
        setCallback({ ...callback, func: null });
        dialogClose();
    };

    const dialogClose = () => {
        setOpenDialog(false);
    };

    const dialogOpen = () => {
        setOpenDialog(true);
    };

    const savePatientSitting = (returnCheck) => {

        var valid = validate();

        if (!valid) {
            setOpenError(true);
            return;
        }

        //check and submit
        if (patientSittingDto.AttendantUsername && !returnCheck) {
            checkAttendantWithMultiple(patientSittingDto, submitPatientSitting);
        }
        else
            submitPatientSitting();
    };

    const saveLocationTransfer = (locationId, locationPath, bed) => {
        let dto = patientSittingDto;
        dto.LocationId = locationId;
        dto.LocationPath = locationPath;
        dto.Bed = bed;
        setPatientSittingDto({ ...patientSittingDto, LocationId: locationId, LocationPath: locationPath, Bed: bed });
        setBackDrop(true);
        HttpService.post('/PatientSitting/SavePatientSitting', dto)
            .then((result) => {
                setBackDrop(false);
            },
                (error) => {
                    setBackDrop(false);
                });
    };

    const submitPatientSitting = () => {
        setBackDrop(true);

        var dto = patientSittingDto;

        if (action === "Add") {
            TransactionTime.end();
            TransactionTime.updateData(dto);
        }

        if (dto.Attendant === "") {
            dto.Attendant = null;
            dto.AttendantUsername = null;
        }

        HttpService.post('/PatientSitting/SavePatientSitting', dto)
            .then((result) => {
                setBackDrop(false);
                props.parentCallback();
            },
                (error) => {
                    setBackDrop(false);
                    console.log(error);
                });
    };

    const getRisks = () => {
        setBackDrop(true);
        HttpService.post('/PatientSitting/GetPOSRisk')
            .then((result) => {
                setAllRisks(result.data);
                setRisksDDL(result.data.filter(x => x.ParentRiskId === "0"));
                setBackDrop(false);

                if (props.patientSittingSelected) {
                    var selected = result.data.find(x => x.Risk === props.patientSittingSelected.Risk);
                    var _currentRiskClassifications = result.data.filter(x => x.ParentRiskId !== '0' && (x.ParentRiskId.indexOf(selected.RiskId) > -1));
                    setCurrentRiskClassifications(_currentRiskClassifications);

                    var _classificationsSelected = result.data.filter(x => x.ParentRiskId !== '0' && (props.patientSittingSelected.RiskClassificationId.indexOf(x.RiskId) > -1))
                    setClassificationsSelected(_classificationsSelected);
                }
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getObservationReasons = () => {
        setBackDrop(true);
        HttpService.post('/PatientSitting/GetObservationReasons', { POSGroupId: defaultSite.IntegratedSystem.POSGroupId })
            .then((result) => {
                setObservationReasons(result.data);
                setBackDrop(false);

                if (props.patientSittingSelected && props.patientSittingSelected.ObservationReasonIds) {
                    let selectedReasons = props.patientSittingSelected.ObservationReasonIds.split(',');
                    let _selectedObservationReasons = result.data.filter(item => (selectedReasons.findIndex((x) => parseInt(x, 10) === item.Id) >= 0));
                    setSelectedObservationReasons(_selectedObservationReasons);
                }
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getObservationLog = () => {
        setBackDrop(true);
        HttpService.post('/PatientSitting/GetObservationLog', {
            AppPatientSittingId: props.patientSittingSelected.Id,
            SiteId: defaultSite.id,
            PageCount: observationLogPageCount
        })
            .then((result) => {
                setObservationLogs({ ...observationLogs, data: result.data });
                setEscalationList({ ...escalationList, data: result.escalationList, count: result.escalationListCount });
                setBackDrop(false);

                let showRestraint = false;
                if (result.data.length > 0) {
                    let item = result.data[0];
                    if (!item.Lock && !item.Disabled) {
                        showRestraint = true;
                    }
                }
                setCanRestraint(showRestraint);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getObservationTemplate = () => {
        HttpService.post('/PatientSitting/GetObservationTemplate', { POSGroupId: posGroupId})
            .then((result) => {
                setObservationTemplateBase(result.observationTemplate);
                setInterventionTemplateBase(result.interventionTemplate);
                setSafetyCheckTemplateBase(result.safetyCheckTemplate);
                setLocationCodeTemplateBase(result.locationCodeTemplate);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getClinicalNotes = () => {
        setBackDrop(true);
        HttpService.post('/PatientSitting/GetClinicalNotes', {
            id: props.patientSittingSelected.Id
        })
            .then((result) => {
                setClinicalNoteList({ ...clinicalNoteList, data: result.data });
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const startObservation = () => {
        var item = props.patientSittingSelected;
        HttpService.post('/PatientSitting/StartObservation', {
            pId: item.Id + "", observer: item.ReplacementAttendant, observerUsername: item.ReplacementAttendantUsername
        })
            .then((result) => {

                setPatientSittingDto({ ...patientSittingDto, Status: "Active" });

                if (patientSittings.length > 0) {
                    for (var index = 0; index < patientSittings.length; index++) {
                        if (patientSittings[index].Id === item.Id) {
                            if (patientSittings[index].signHandOffHistory != null) {
                                if (patientSittings[index].signHandOffHistory.IsClinicalRelief === true) {
                                    setIsShowClinicalObservation(true);
                                }
                            }
                        }
                    }
                }

                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const saveManagerComments = () => {
        setBackDrop(true);
        HttpService.post('/PatientSitting/SaveManagerComments', observationLogDto)
            .then((result) => {
                setBackDrop(false);
                setIsShowManagerComments(false);
                getObservationLog();
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const saveClinicalObservation = () => {

        if (!clinicalNotes) {
            setErrorMessage("Please enter an Notes");
            setOpenError(true);
            return;
        }

        setBackDrop(true);
        HttpService.post('/PatientSitting/SaveClinicalNotes', {
            AppPatientSittingId: patientSittingDto.Id,
            ClinicalNotes: clinicalNotes
        })
            .then((result) => {
                setBackDrop(false);
                setIsShowClinicalObservation(false);
                getClinicalNotes();
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    };

    const getRestraintCheckList = () => {
        let dto = restraintCheckListItem;
        dto.AppPatientSittingId = props.patientSittingSelected.Id;
        setBackDrop(true);
        HttpService.post('/PatientSitting/GetRestraintCheckList', dto)
            .then((result) => {
                setBackDrop(false);
                let data = result.data;
                data.RestraintCheckListItem.RestraintTypesArr = JSON.parse(data.RestraintCheckListItem.RestraintTypes);
                setRestraintCheckListItem(data.RestraintCheckListItem);

                data.HistoryItems.forEach(x => {
                    let typeArr = JSON.parse(x.RestraintTypes);
                    if (typeArr && typeArr.length > 0) {
                        let arr = [];
                        typeArr.forEach(t => {
                            if (t.Checked) {
                                arr.push(t.Text);
                            }
                        });
                        x.SelectedRestraintTypes = arr.join(', ');
                    }
                });
                setRestraintCheckListHistoryItem({ ...restraintCheckListHistoryItem, data: data.HistoryItems });
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    }

    const restraintDialogConfirm = () => {
        onRestraintStart();
        restraintDialogClose();
    };

    const restraintDialogClose = () => {
        setOpenRestraintDialog(false);
    };

    const restraintDialogOpen = () => {
        setOpenRestraintDialog(true);
    };

    const onRestraintStart = () => {
        let dto = restraintCheckListItem;
        dto.AppPatientSittingId = props.patientSittingSelected.Id;
        dto.Started = true;
        setBackDrop(true);
        HttpService.post('/PatientSitting/SaveRestraintCheckList', dto)
            .then((result) => {
                setBackDrop(false);
                getRestraintCheckList();
                autoPopulateInterventionOptions(true, false);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });
    }

    const autoPopulateInterventionOptions = (start, stop) => {
        let items = observationLogs.data;
        if (items.length > 0) {
            let dto = items[0];
            if (!dto.Lock && !dto.Disabled) {
                var templates = {
                    observationOptions: JSON.parse(JSON.stringify(observationTemplateBase)),
                    interventionOptions: JSON.parse(JSON.stringify(interventionTemplateBase)),
                    safetyCheckOptions: JSON.parse(JSON.stringify(safetyCheckTemplateBase))
                };

                dto.ObservationIds = "";
                dto.InterventionIds = "";
                dto.SafetyCheckIds = "";

                if (dto.ObservationInterventionJson) {
                    templates = JSON.parse(dto.ObservationInterventionJson);
                }

                templates.observationOptions.forEach((item) => {
                    if (item.Checked) {
                        dto.ObservationIds += item.CodeID + ",";
                    }
                });

                templates.interventionOptions.forEach((item) => {
                    if (start && item.CodeID === "PRA") {
                        item.Checked = true
                    }
                    if (stop && item.CodeID === "PRR") {
                        item.Checked = true
                    }

                    if (item.Checked) {
                        dto.InterventionIds += item.CodeID + ",";
                    }
                });

                templates.safetyCheckOptions.forEach((item) => {
                    if (item.Checked) {
                        dto.SafetyCheckIds += item.CodeID + ",";
                    }
                });

                dto.ObservationInterventionJson = JSON.stringify(templates);

                HttpService.post('/PatientSitting/SaveObservationLog',
                    dto
                )
                    .then((result) => {
                        getObservationLog();
                    },
                        (error) => {
                            //This is intentional
                        });
            }
        }
    };


    const initRestraintCheckListItem = () => {
        var base = JSON.parse(JSON.stringify(restraintCheckListItemBase));
        setRestraintCheckListItem(base);
    }

    const initObservationLog = () => {
        var _observationOptions = JSON.parse(JSON.stringify(observationTemplateBase));
        var _interventionOptions = JSON.parse(JSON.stringify(interventionTemplateBase));
        var _safetyCheckOptions = JSON.parse(JSON.stringify(safetyCheckTemplateBase));
        var _locationCodeOptions = JSON.parse(JSON.stringify(locationCodeTemplateBase));
        setObservationOptions(_observationOptions);
        setInterventionOptions(_interventionOptions);
        setSafetyCheckOptions(_safetyCheckOptions);
        setLocationCodeOptions(_locationCodeOptions);
    };

    const fillObservationLog = (dto, autoPopulateIntervention) => {
        var _dto = { ...observationLogDto };
        _dto.Id = dto.Id;
        _dto.ObservationTimeString = dto.ObservationTimeString;

        if (dto.Observer) {
            _dto.Observer = dto.Observer;
            _dto.ObserverUsername = dto.ObserverUsername;
        }
        else {
            //default to patientSitting Attendant
            _dto.Observer = patientSittingDto.Attendant;
            _dto.ObserverUsername = patientSittingDto.AttendantUsername;
        }

        _dto.Comments = dto.Comments;
        var templates = {
            observationOptions: observationOptions,
            interventionOptions: interventionOptions,
            safetyCheckOptions: safetyCheckOptions,
            locationCodeOptions: locationCodeOptions
        };

        if (dto.ObservationIds !== null) {
            if (dto.ObservationIds.indexOf("NR2") > -1) {
                templates.observationOptions.forEach((item) => {
                    if (item.CodeID === "NR2") {
                        item.Checked = true
                    }
                });
                setObservationOptions(templates.observationOptions);
                setInterventionOptions(templates.interventionOptions);
                setSafetyCheckOptions(templates.safetyCheckOptions);
                setLocationCodeOptions(templates.locationCodeOptions);
            }
        }

        if (dto.ObservationInterventionJson) {
            var template = JSON.parse(dto.ObservationInterventionJson);
            if (autoPopulateIntervention) {
                templates.interventionOptions.forEach((item) => {
                    if (autoPopulateIntervention.Start && item.CodeID === "PRA") {
                        item.Checked = true
                    }
                    if (autoPopulateIntervention.Stop && item.CodeID === "PRR") {
                        item.Checked = true
                    }
                });
            }
            setObservationOptions(template.observationOptions);
            setInterventionOptions(template.interventionOptions);
            setSafetyCheckOptions(template.safetyCheckOptions);
            setLocationCodeOptions(template.locationCodeOptions);
        }
        setObservationLogDto(_dto);
    };

    const showContact = () => {
        setIsShowContact(true);
    };

    const showSignHandOff = () => {
        setIsShowSignHandOff(true);
        setHideSignHandOffConfirm(false);
    };

    const showPatientFell = () => {
        setIsShowPatientFell(true);
    };

    const showAttendantCheckList = () => {
        setIsShowAttendantCheckList(true);
    };

    const showClinicalNotes = () => {
        setIsShowClinicalNotes(true);
    };

    const showTransferPopup = () => {
        setIsShowTransferLocation(true);
        setHideTransferLocationConfirm(false);
    };

    const onHideTransferLocationConfirm = (isHide) => {
        setHideTransferLocationConfirm(isHide);
    };

    const showEnvironmentalChecklist = () => {
        setIsShowEnvironmentalChecklist(true);
    };

    const showRestraintCheckList = () => {
        setIsShowRestraintCheckList(true);
    }

    const showRestraintCheckListHistory = () => {
        setIsShowRestraintCheckListHistory(true);
    }

    const showFoodTrayChecklist = () => {
        setIsShowFoodTrayChecklist(true);
    };

    const showManagerComments = (dto) => {
        setObservationLogDto({ ...observationLogDto, Id: dto.Id, ManagerComments: dto.ManagerComments });
        setIsShowManagerComments(true);
    };

    const onShowObservationLogAdd = (item) => {

        if (item.Lock || item.Disabled) {
            return;
        }
        if (item.ObservationIds === "NR1") {
            setErrorMessage("In order to edit, please end Clinical Relief and hand off to an Attendant");
            setOpenError(true);
            return;
        }

        initObservationLog();
        fillObservationLog(item);
        setIsShowObservationLogAdd(true);
    };

    const getShortName = (name) => {
        if (name.indexOf("\\") === -1)
            return name;
        else
            return ".." + name.substring(name.indexOf("\\"));
    };

    const onHideSignHandOffConfirm = (isHide) => {
        setHideSignHandOffConfirm(isHide);
    };

    const onHidePatientFellConfirm = (isHide) => {
        setHidePatientFellConfirm(isHide);
    };

    const closeTimerDialog = () => {
        setTimerOpen(false);
    };

    const openAddPatientStatus = () => {
        if (!isManager) return;
        setPatientStatusOpen(true);
    };

    const closeAddPatientStatus = () => {
        setPatientStatusOpen(false);
    };

    const triggerPatientStatusSave = () => {
        patientStatusRef.current.save();
    };

    useEffect(() => {
        let data = observationLogs.data;
        if (data.length > 0 && data[0].Observer === null && (data[0].RemainingTime === 1 || data[0].RemainingTime === 0)) {
            if (!timerOpen) {
                const synth = window.speechSynthesis;
                const utterance = new SpeechSynthesisUtterance("Attention!, this is a remainder. We are now approaching the end of the 15 minute period. Please complete your observation. Thank you.");
                synth.speak(utterance);
                setRemainingTime((data[0].RemainingTime + 1) * 60);
                setTimerOpen(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [observationLogs]);

    useEffect(() => {

        if ((posGroupId === 1) && allRisks.length === 0) {
            getRisks();
        }

        if ((posGroupId === 2) && observationReasons.length === 0) {
            getObservationReasons();
        }

        if (props.patientSittingSelected) {
            setAction("Edit");
            setCollapse(true);
            setSelectedLocation([{ GeoLocationBranchName: props.patientSittingSelected.LocationPath }]);
            setPatientObservationAttendantDto({ ...props.patientSittingSelected.POSAttendantChecklist });
            if (props.patientSittingSelected.Attendant) {
                var name = props.patientSittingSelected.Attendant.split(' ');
                setAttendantSelected({ FirstName: name[0], LastName: name[1] });
                //fill POSAttendantChecklist model                
            }
        }
        else {
            setShowInactiveMessage(true);
            TransactionTime.begin('PatientSittingEdit');
            setBackDrop(false);
        }

        var interval = null;
        if (props.showObservation) {
            getObservationLog();
            interval = setInterval(function () { getObservationLog() }, 60000);
            getObservationTemplate();
            getClinicalNotes();
            getRestraintCheckList();
        }

        if (props.isStartObservation) {
            startObservation();
        }

        return () => clearInterval(interval);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (<>
        <Backdrop className={classes.backdrop} id="addPatientSittingBackdrop" open={backDrop}>
            <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
            <Alert onClose={closeErrorSnackbar} severity="error">
                {errorMessage}
            </Alert>
        </Snackbar>
        <AlertDialog handleClose={dialogClose} handlePositive={dialogConfirm} open={openDialog} message={messageDialog} buttonName="Confirm"></AlertDialog>
        <AlertDialog handleClose={restraintDialogClose} handlePositive={restraintDialogConfirm} open={openRestraintDialog} message={messageRestraintDialog} buttonName="Confirm"></AlertDialog>
        <ContentDialog open={isShowEscalations} title="Escalations" hideConfirm={true} maxWidth={"lg"} close={() => setIsShowEscalations(false)}>
            <EscalationList escalationList={escalationList}></EscalationList>
        </ContentDialog>
        <ContentDialog open={isShowPatientFell} title="Patient Fell" maxWidth={"sm"} close={() => setIsShowPatientFell(false)} onConfirm={() => { patientFellRef.current.save() }} disableWithStyle={disableWithStyle} hideAllConfirm={hidePatientFellConfirm} >
            <PatientFellAdd ref={patientFellRef} close={() => setIsShowPatientFell(false)} patientSittingDto={patientSittingDto} onDisableWithStyle={(disable) => { setDisableWithStyle(disable) }} onHidePatientFellConfirm={onHidePatientFellConfirm}></PatientFellAdd>
        </ContentDialog>
        <ContentDialog open={isShowTransferLocation} title="Transfer Location" maxWidth={"md"} disableWithStyle={disableWithStyle} close={() => setIsShowTransferLocation(false)} onConfirm={() => { locationTransfertRef.current.save() }} hideAllConfirm={hideTransferLocationConfirm}>
            <TransferLocationAdd ref={locationTransfertRef} patientSittingDto={patientSittingDto} defaultSite={defaultSite} locations={locations} onDisableWithStyle={(disable) => { setDisableWithStyle(disable) }} close={() => setIsShowTransferLocation(false)} saveLocationTransfer={saveLocationTransfer} onHideTransferLocationConfirm={onHideTransferLocationConfirm}></TransferLocationAdd>
        </ContentDialog>
        <ContentDialog open={isShowAttendantCheckList} closeName={'Decline'} confirmName={'Accept'} title="Patient Observation Attendant Checklist" styleTitle={{ color: '#4183c4' }} maxWidth={"lg"} disableWithStyle={disableWithAttendantCheckList} close={() => { attendantCheckListRef.current.cancel(); setIsShowAttendantCheckList(false); }} onConfirm={() => { attendantCheckListRef.current.save(); }}>
            <AttendantCheckList ref={attendantCheckListRef} attendants={attendants} patientSittingSelected={props.patientSittingSelected} selectPatientObservationAttendantDto={patientObservationAttendantDto} onDisableWithStyle={(disable) => { setDisableWithAttendantCheckList(disable) }} isManuallyShowAttendantCheckList={true} close={() => setIsShowAttendantCheckList(false)}></AttendantCheckList>
        </ContentDialog>
        <ContentDialog open={isShowContact} title="Contact" maxWidth={"lg"} close={() => setIsShowContact(false)} onConfirm={() => { contactRef.current.save() }}>
            <ContactAdd ref={contactRef} patientSittingDto={patientSittingDto} close={() => setIsShowContact(false)}></ContactAdd>
        </ContentDialog>
        <ContentDialog open={isShowClinicalNotes} title="Clinical Notes" hideConfirm={true} maxWidth={"lg"} close={() => setIsShowClinicalNotes(false)}>
            <ClinicalNoteList clinicalNoteList={clinicalNoteList} ></ClinicalNoteList>
        </ContentDialog>
        <ContentDialog open={isShowEnvironmentalChecklist} title="Suicide Environmental Checklist" maxWidth={"lg"} disableWithStyle={disableWithStyle} close={() => setIsShowEnvironmentalChecklist(false)} onConfirm={() => { environmentalChecklistRef.current.save() }}>
            <EnvironmentalChecklistAdd ref={environmentalChecklistRef} onDisableWithStyle={(disable) => { setDisableWithStyle(disable) }} close={() => setIsShowEnvironmentalChecklist(false)}></EnvironmentalChecklistAdd>
        </ContentDialog>
        <ContentDialog open={isShowObservationLogAdd} title="Observation Log" maxWidth={"lg"} close={() => setIsShowObservationLogAdd(false)} onConfirm={() => { observationLogRef.current.save() }}>
            <ObservationLogAdd ref={observationLogRef} attendants={attendants} observationLogSelected={observationLogDto} observationTemplate={observationOptions} interventionTemplate={interventionOptions} safetyCheckTemplate={safetyCheckOptions} locationCodeTemplate={locationCodeOptions} getObservationLog={getObservationLog} close={() => setIsShowObservationLogAdd(false)}></ObservationLogAdd>
        </ContentDialog>
        <ContentDialog open={isShowSignHandOff} title="Sign Off/Hand Off" maxWidth={"lg"} close={() => setIsShowSignHandOff(false)} hideConfirm={hideSignHandOffConfirm} onConfirm={() => { signHandOffRef.current.save() }} disableWithStyle={disableWithStyle}>
            <SignHandOffAdd ref={signHandOffRef} onDisableWithStyle={(disable) => { setDisableWithStyle(disable) }} maxWidth={"lg"} close={() => setIsShowSignHandOff(false)} patientSittings={patientSittings} attendants={attendants} clinicalCheckboxShow={true} patientSittingDto={patientSittingDto} checkAttendantWithMultiple={checkAttendantWithMultiple} savePatientSitting={savePatientSitting} siteId={defaultSite.id} onHideSignHandOffConfirm={onHideSignHandOffConfirm}></SignHandOffAdd>
        </ContentDialog>
        <ContentDialog open={isShowFoodTrayChecklist} title="Food Tray Checklist" maxWidth={"lg"} close={() => setIsShowFoodTrayChecklist(false)} onConfirm={() => { foodTrayChecklistRef.current.save() }}>
            <FoodTrayChecklist ref={foodTrayChecklistRef} patientSittingDto={patientSittingDto} close={() => setIsShowFoodTrayChecklist(false)}></FoodTrayChecklist>
        </ContentDialog>
        <ContentDialog open={isShowRestraintCheckList} title="Restraint Type Checklist" maxWidth={"lg"} close={() => setIsShowRestraintCheckList(false)} onConfirm={() => { restraintCheckListRef.current.save() }}>
            <RestraintCheckList ref={restraintCheckListRef} restraintCheckListItem={restraintCheckListItem} close={() => setIsShowRestraintCheckList(false)} getRestraintCheckList={getRestraintCheckList} initRestraintCheckListItem={initRestraintCheckListItem} autoPopulateInterventionOptions={autoPopulateInterventionOptions}></RestraintCheckList>
        </ContentDialog>
        <ContentDialog open={isShowRestraintCheckListHistory} title="Restraint Type Checklist History" hideConfirm={true} maxWidth={"lg"} close={() => setIsShowRestraintCheckListHistory(false)}>
            <RestraintCheckListHistory restraintCheckListHistoryItem={restraintCheckListHistoryItem} ></RestraintCheckListHistory>
        </ContentDialog>
        <ContentDialog open={isShowRestraintCheckListHistory} title="Restraint Type Checklist History" hideConfirm={true} maxWidth={"lg"} close={() => setIsShowRestraintCheckListHistory(false)}>
            <RestraintCheckListHistory restraintCheckListHistoryItem={restraintCheckListHistoryItem} ></RestraintCheckListHistory>
        </ContentDialog>
        <FullScreenDialog open={patientStatusOpen} title="New Patient Status" save={true} hideConfirm={true} maxWidth={"lg"} close={() => closeAddPatientStatus()} onConfirm={triggerPatientStatusSave} currentTheme={currentTheme} >
            <PatientStatusAdd ref={patientStatusRef}
                parentCallback={closeAddPatientStatus}
                theme={currentTheme}
                patientSittingDto={patientSittingDto}
            />
        </FullScreenDialog>
        <ContentDialog open={isShowManagerComments} title="Manager Comments" maxWidth={"lg"} close={() => setIsShowManagerComments(false)} onConfirm={saveManagerComments} >
            <TextField size="small" fullWidth
                multiline
                rows="4"
                label="Comments"
                variant="outlined"
                value={observationLogDto.ManagerComments || ""}
                onChange={(e) => { setObservationLogDto({ ...observationLogDto, ManagerComments: e.target.value.trimStart() }); }}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        </ContentDialog>
        <ContentDialog open={isShowClinicalObservation} title="Clinical Observation" maxWidth={"lg"} close={() => setIsShowClinicalObservation(false)} onConfirm={saveClinicalObservation} >
            <TextField size="small" fullWidth
                multiline
                rows="4"
                label="Notes"
                variant="outlined"
                value={clinicalNotes || ""}
                onChange={(e) => { setClinicalNotes(e.target.value); }}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        </ContentDialog>
        {(timerOpen) && (
            <TimerDialog open={timerOpen} initialRemainingTime={remainingTime} onClose={closeTimerDialog} />
        )}
        <div className={classes.root} autoComplete="off">
            <Grid container
                direction="row"
                justify="space-between"
                alignItems="center"
                spacing={5}
                className={'mt-2'}
            >

                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    className={classes.newButton}
                    style={{ width: "150px", marginLeft: "5px" }}
                    onClick={openAddPatientStatus}
                >
                    Patient Status
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    className={classes.newButton}
                    style={{ width: "150px", marginLeft: "5px" }}
                    onClick={showPatientFell}
                >
                    Patient Fell
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    className={classes.newButton}
                    style={{ width: "200px", marginLeft: "5px" }}
                    onClick={showAttendantCheckList}
                >
                    Attendant checklist
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    className={classes.newButton}
                    style={{ width: "200px", marginLeft: "5px" }}
                    onClick={showSignHandOff}
                >
                    Sign Off/Hand Off
                </Button>
                <MailOutlineIcon className={classes.newButton} fontSize="large" style={{ cursor: 'pointer' }} onClick={showContact} />


            </Grid>
            {
                !showObservation &&
                <ValidatorForm className={classes.root} autoComplete="off" onSubmit={savePatientSitting} reflectchanges={reflect.toString()}>
                    {<>
                        <Grid
                            container
                            direction="row"
                            alignItems="center"
                            spacing={1}>

                            {(!collapse || !props.showObservation) &&
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant="subtitle2" gutterBottom>
                                            Start Date <span style={{ color: 'red' }}>*</span>
                                        </Typography>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDateTimePicker fullWidth hideTabs autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                id="PatientSittingDateTime"
                                                format="MM/dd/yyyy hh:mm a"
                                                size="small"
                                                disableFuture="true"
                                                value={patientSittingDto.StartDate}
                                                onChange={date => patientSittingDtoDateChanged('StartDate', date)}
                                                disabled={!isManager || (patientSittingDto.Id > 0 && patientSittingDto.Status !== 'Scheduled' && patientSittingDto.Status !== 'Ready')}
                                                InputAdornmentProps={{ position: "start" }}
                                                PopoverProps={{
                                                    anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                    transformOrigin: { horizontal: "left", vertical: "top" }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant="subtitle2" gutterBottom>
                                            End Date <span style={{ color: 'red' }}>*</span>
                                        </Typography>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDateTimePicker fullWidth hideTabs autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                id="PatientSittingDateTime"
                                                format="MM/dd/yyyy hh:mm a"
                                                size="small"
                                                //disablePast="true"
                                                value={patientSittingDto.EndDate}
                                                onChange={date => patientSittingDtoDateChanged('EndDate', date)}
                                                InputAdornmentProps={{ position: "start" }}
                                                PopoverProps={{
                                                    anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                    transformOrigin: { horizontal: "left", vertical: "top" }
                                                }}
                                                disabled={!isManager}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={1}>
                                        <Grid item xs={12} sm={6} className={'mt-2'}>
                                            <Typography variant="subtitle2" gutterBottom>
                                                Request Date <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDateTimePicker fullWidth hideTabs autoOk
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    id="PatientSittingDateTime"
                                                    format="MM/dd/yyyy hh:mm a"
                                                    size="small"
                                                    disableFuture="true"
                                                    value={patientSittingDto.RequestDate}
                                                    onChange={date => patientSittingDtoDateChanged('RequestDate', date)}
                                                    disabled={!isManager}
                                                    InputAdornmentProps={{ position: "start" }}
                                                    PopoverProps={{
                                                        anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                        transformOrigin: { horizontal: "left", vertical: "top" }
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} sm={12} className={'mt-2 mb-2'}>
                                        <Typography variant="subtitle2" gutterBottom>
                                            Requestor <span style={{ color: 'red' }}>*</span>
                                        </Typography>
                                        <TextField size="small" fullWidth
                                            variant="outlined"
                                            value={patientSittingDto.Requestor || ""}
                                            onChange={(e) => { setModified(true); props.inputValueChanged(); setPatientSittingDto({ ...patientSittingDto, Requestor: e.target.value.trimStart() }); }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            disabled={!isManager}
                                        />
                                    </Grid>
                                </>
                            }

                            <Grid item xs={12} sm={12}>
                                <Typography variant="subtitle2" gutterBottom>
                                    Request Type <span style={{ color: 'red' }}>*</span>
                                </Typography>
                                <RadioGroup
                                    aria-label="position"
                                    name="position"
                                    value={patientSittingDto.RequestType}
                                    onChange={(e) => onRequestTypeChanged(e)}
                                    disabled={!isManager}
                                    row
                                >
                                    {
                                        requestTypeDDL.map((option) =>

                                            <FormControlLabel
                                                key={option.Name}
                                                value={option.Name}
                                                control={<Radio style={{ color: currentTheme.secondary }} />}
                                                label={option.Name}
                                                labelPlacement="end"
                                                style={{ color: currentTheme.text }}
                                            />
                                        )
                                    }
                                </RadioGroup>
                            </Grid>

                            <Grid item xs={12} sm={12}>
                                <Typography variant="subtitle2" gutterBottom>
                                    Attendant (Optional)
                                </Typography>
                                <Autocomplete
                                    size="small"
                                    id="Attendant"
                                    options={attendants || []}
                                    getOptionLabel=
                                    {
                                        (option) => `${option?.FirstName == null ? '' : option.FirstName} ${option?.LastName == null ? '' : option.LastName}`
                                    }
                                    disabled={!isManager}
                                    value={attendantSelected}
                                    filterSelectedOptions
                                    getOptionSelected={(option, value) => option.FirstName === value.FirstName}
                                    onChange={(e, v) => onAttendantSelected(e, v, 13)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            placeholder="Attendant"
                                        />
                                    )}
                                />
                            </Grid>


                            <Grid item xs={12} sm={12}>
                                <Typography variant="subtitle2" gutterBottom>
                                    Location <span style={{ color: 'red' }}>*</span>
                                </Typography>
                                <Typeahead
                                    id="LocationList"
                                    labelKey="GeoLocationBranchName"
                                    placeholder="Choose a Location..."
                                    options={locations}
                                    selected={selectedLocation}
                                    disabled={!isManager}
                                    onChange={(e) => locationChanged(e)}
                                    renderMenuItemChildren={(option, key) => (
                                        <>
                                            <div className="dropdown-widget">
                                                <div className="left">{getShortName(option.GeoLocationBranchName)}</div>
                                            </div>
                                        </>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography variant="subtitle2" gutterBottom>
                                    Bed <span style={{ color: 'red' }}>*</span>
                                </Typography>
                                <TextField size="small" fullWidth
                                    variant="outlined"
                                    value={patientSittingDto.Bed || ""}
                                    disabled={!isManager}
                                    onChange={(e) => { setModified(true); props.inputValueChanged(); setPatientSittingDto({ ...patientSittingDto, Bed: e.target.value.trimStart() }); }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography variant="subtitle2" gutterBottom>
                                    Patient Name <span style={{ color: 'red' }}>*</span>
                                </Typography>
                                <TextField size="small" fullWidth
                                    variant="outlined"
                                    value={patientSittingDto.PatientName || ""}
                                    disabled={!isManager}
                                    onChange={(e) => { setModified(true); props.inputValueChanged(); setPatientSittingDto({ ...patientSittingDto, PatientName: e.target.value.trimStart() }); }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            {(!collapse || !props.showObservation) &&
                                <>

                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={1} className={'mt-2 mb-2'}>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2" gutterBottom>
                                                Patient DOB <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker fullWidth hideTabs autoOk
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    id="PatientSittingDateTime"
                                                    format="MM/dd/yyyy"
                                                    size="small"
                                                    disableFuture="true"
                                                    value={patientSittingDto.DateBirth}
                                                    onChange={date => patientSittingDtoDateChanged('DateBirth', date)}
                                                    InputAdornmentProps={{ position: "start" }}
                                                    PopoverProps={{
                                                        anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                        transformOrigin: { horizontal: "left", vertical: "top" }
                                                    }}
                                                    disabled={!isManager}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2" gutterBottom>
                                            Patient {(posGroupId === 1) ? 'MRN' : 'FIN' }<span style={{ color: 'red' }}> *</span>
                                            </Typography>
                                            <TextField size="small" fullWidth
                                                variant="outlined"
                                                value={patientSittingDto.MedicalRecordNumber || ""}
                                                onChange={(e) => { setModified(true); props.inputValueChanged(); setPatientSittingDto({ ...patientSittingDto, MedicalRecordNumber: e.target.value.trimStart() }); }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                disabled={!isManager}
                                            />
                                        </Grid>
                                    </Grid>

                                    {(posGroupId === 1) &&
                                        <Grid
                                            container
                                            direction="row"
                                            alignItems="center"
                                            spacing={1} className={'mt-2'}>
                                            <Grid item xs={12} sm={6}>
                                                <Typography variant="subtitle2" gutterBottom>
                                                    Patient Type <span style={{ color: 'red' }}>*</span>
                                                </Typography>
                                                <RadioGroup
                                                    aria-label="position"
                                                    name="position"
                                                    value={patientSittingDto.PatientType}
                                                    onChange={(e) => onPatientTypeChanged(e)}
                                                    disabled={!isManager}
                                                    row
                                                >
                                                    {
                                                        patientTypeDDL.map((option) =>

                                                            <FormControlLabel
                                                                key={option.Name}
                                                                value={option.Name}
                                                                control={<Radio style={{ color: currentTheme.secondary }} />}
                                                                label={option.Name}
                                                                labelPlacement="end"
                                                                style={{ color: currentTheme.text }}
                                                            />
                                                        )
                                                    }
                                                </RadioGroup>
                                            </Grid>
                                        </Grid>
                                    }
                                    {(posGroupId === 2) &&
                                        <Grid
                                            container
                                            direction="row"
                                            alignItems="center"
                                            spacing={1} className={'mt-2'}>
                                            <Grid item xs={12} sm={6}>
                                                <Typography variant="subtitle2" gutterBottom>
                                                    Patient Demographic <span style={{ color: 'red' }}>*</span>
                                                </Typography>
                                                <RadioGroup
                                                    aria-label="position"
                                                    name="position"
                                                    value={patientSittingDto.PatientDemographic}
                                                    onChange={(e) => onPatientDemographicChanged(e)}
                                                    disabled={!isManager}
                                                    row
                                                >
                                                    {
                                                        patientTypeDDL.map((option) =>
                                                            <FormControlLabel
                                                                key={option.Name}
                                                                value={option.Name}
                                                                control={<Radio style={{ color: currentTheme.secondary }} />}
                                                                label={option.Name}
                                                                labelPlacement="end"
                                                                style={{ color: currentTheme.text }}
                                                            />
                                                        )
                                                    }
                                                </RadioGroup>
                                            </Grid>
                                        </Grid>
                                    }
                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={1} className={'mt-2'}>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2" gutterBottom>
                                                Isolation Patient <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <RadioGroup
                                                aria-label="position"
                                                name="position"
                                                value={patientSittingDto.IsolationPatient}
                                                onChange={(e) => onIsolationPatientChanged(e)}
                                                disabled={!isManager}
                                                row
                                            >
                                                {
                                                    isolationPatientDDL.map((option) =>
                                                        <FormControlLabel
                                                            key={option.Name}
                                                            value={option.Name}
                                                            control={<Radio style={{ color: currentTheme.secondary }} />}
                                                            label={option.Name}
                                                            labelPlacement="end"
                                                            style={{ color: currentTheme.text }}
                                                        />
                                                    )
                                                }
                                            </RadioGroup>
                                        </Grid>
                                    </Grid>
                                {(posGroupId === 1) &&
                                <>
                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={1} className={'mt-2'}>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2" gutterBottom>
                                                Risk <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <RadioGroup
                                                aria-label="position"
                                                name="position"
                                                value={patientSittingDto.Risk || ''}
                                                onChange={(e) => onRiskChanged(e)}
                                                disabled={!isManager}
                                                row
                                            >
                                                {
                                                    risksDDL.map((option) =>
                                                        <FormControlLabel
                                                            key={option.Risk}
                                                            value={option.Risk}
                                                            control={<Radio style={{ color: currentTheme.secondary }} />}
                                                            label={option.Risk}
                                                            labelPlacement="end"
                                                            style={{ color: currentTheme.text }}
                                                        />
                                                    )
                                                }
                                            </RadioGroup>
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={1} className={'mt-2'}>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2" gutterBottom>
                                                Classification <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <Autocomplete
                                                multiple
                                                size="small"
                                                id="Classification"
                                                options={currentRiskClassifications}
                                                getOptionLabel={(option) => `${option?.Risk}`}
                                                value={classificationsSelected}
                                                disabled={!isManager}
                                                disablePortal={true}
                                                filterSelectedOptions
                                                onChange={(e, v) => onClassificationSelected(e, v, 13)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                                }
                                    {(posGroupId === 2) &&
                                        <>
                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={1} className={'mt-2'}>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2" gutterBottom>
                                                Patient Type <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <RadioGroup
                                                aria-label="position"
                                                name="position"
                                                value={patientSittingDto.PatientType}
                                                onChange={(e) => onPatientTypeChanged(e)}
                                                disabled={!isManager}
                                                row
                                            >
                                                {
                                                    patientTypeInspiraDDL.map((option) =>
                                                        <FormControlLabel
                                                            key={option.Name}
                                                            value={option.Name}
                                                            control={<Radio style={{ color: currentTheme.secondary }} />}
                                                            label={option.Name}
                                                            labelPlacement="end"
                                                            style={{ color: currentTheme.text }}
                                                        />
                                                    )
                                                }
                                            </RadioGroup>
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                        spacing={1} className={'mt-2'}>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2" gutterBottom>
                                                Reason for Observation <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <FormControl fullWidth variant="outlined" margin="dense" className={classes.ddl}>
                                                <Select
                                                    labelId="ObservationReasonLabel"
                                                    id="ObservationReason"
                                                    multiple
                                                    value={selectedObservationReasons}
                                                    onChange={onObservationReasonChanged}
                                                    input={<OutlinedInput />}
                                                    renderValue={(selected) => selected.map((x) => x.Description).join(', ')}
                                                >
                                                    {observationReasons.map((reason) => (
                                                        <MenuItem key={reason.Id} value={reason}>
                                                            <Checkbox checked={selectedObservationReasons.findIndex((item) => item.Id === reason.Id) >= 0} />
                                                            <ListItemText primary={reason.Description} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        </Grid>
                                    </>
                                }

                                </>
                            }

                            <Grid item xs={12} sm={12}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    className="mt-3"
                                    disabled={!isManager}
                                    style={{ background: currentTheme.secondary, width: "150px" }}
                                    type="submit"
                                    onSubmit={savePatientSitting}
                                >
                                    Save
                                </Button>
                            </Grid>
                        </Grid>
                    </>
                    }
                </ValidatorForm>
            }

            {showObservation &&
                <>
                    <Grid container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        spacing={1}>
                        <Grid item>
                            <Typography variant="h6" gutterBottom>
                                Patient Name: {patientSittingDto.PatientName}
                            </Typography>
                        </Grid>
                        <Grid item>
                            {escalationList.count > 0 &&
                                <>
                                    <ErrorOutlineIcon style={{ color: 'red' }}></ErrorOutlineIcon>
                                    <u style={{ color: 'red', cursor: 'pointer', marginLeft: "5px", display: "block", float: "right", fontSize: "18px" }} onClick={() => { setIsShowEscalations(true) }}>{escalationList.count} Escalation</u>
                                </>
                            }
                        </Grid>
                    </Grid>
                    <Grid container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        spacing={1}>
                        <Grid item>
                            <Typography variant="subtitle2" gutterBottom>
                                Attendant
                            </Typography>
                            <Typography variant="body2" gutterBottom >
                                <strong> {props.patientSittingSelected.Attendant}</strong>
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle2" gutterBottom>
                                Location
                            </Typography>
                            <Typography variant="body2" gutterBottom >
                                <strong> {patientSittingDto.LocationPath}</strong>
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle2" gutterBottom>
                                Bed
                            </Typography>
                            <Typography variant="body2" gutterBottom >
                                <strong> {patientSittingDto.Bed}</strong>
                            </Typography>
                        </Grid>
                        {isManager &&
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    style={{ background: '#60a917', width: "100px", marginLeft: "5px" }}
                                    onClick={showTransferPopup}
                                >
                                    Transfer
                                </Button>
                            </Grid>
                        }
                        <Grid item>
                            {
                                clinicalNoteList.data.length > 0 &&
                                <u style={{ cursor: 'pointer' }} onClick={showClinicalNotes}>Clinical Notes</u>
                            }

                        </Grid>
                    {(posGroupId === 1) &&
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className={classes.button}
                                style={{ background: '#60a917', width: "250px", marginLeft: "5px" }}
                                startIcon={<AddIcon />}
                                onClick={showEnvironmentalChecklist}
                            >
                                Environmental Checklist
                            </Button>
                        </Grid>
                    }
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className={classes.button}
                                style={{ background: '#60a917', width: "250px", marginLeft: "5px" }}
                                onClick={showFoodTrayChecklist}
                            >
                                Food Tray Checklist
                            </Button>
                        </Grid>
                    {(posGroupId === 1) &&
                        <Grid item>
                            {
                                restraintCheckListItem.Started &&
                                <div className={classes.restraintButtonGroup}>
                                    Restraints added at {restraintCheckListItem.StartTimeString}
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        style={{ background: '#60a917', width: "100px", marginLeft: "5px" }}
                                        onClick={showRestraintCheckList}
                                        disabled={!canRestraint}
                                    >
                                        STOP
                                    </Button>
                                </div>
                            }
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className={classes.button}
                                style={{ background: '#60a917', width: "160px", marginLeft: "5px" }}
                                onClick={() => { setIsShowRestraintCheckListHistory(true) }}
                            >
                                Restraint History
                            </Button>
                            {
                                !restraintCheckListItem.Started &&
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    style={{ background: '#60a917', width: "160px", marginLeft: "5px" }}
                                    onClick={restraintDialogOpen}
                                    disabled={!canRestraint}
                                >
                                    Restraint START
                                </Button>
                            }
                        </Grid>
                    }
                        <Grid className="material-table" item xs={12} sm={12}>
                            <MaterialTable
                                title=""
                                columns={observationLogs.columns}
                                data={observationLogs.data}
                                onRowClick={(event, rowData) => { onShowObservationLogAdd(rowData); }}
                                components={{
                                    Toolbar: (props) => (
                                        <div
                                            style={{
                                                height: "0px",
                                            }}
                                        >
                                            <MTableToolbar {...props} />
                                        </div>
                                    )
                                }}
                                style={{ backgroundColor: currentTheme.background, border: '1px solid white' }}
                                options={{
                                    filtering: false,
                                    search: false,
                                    actionsColumnIndex: -1,
                                    minBodyHeight: "55vh", maxBodyHeight: "55vh",
                                    headerStyle: {
                                        fontWeight: 'bold', color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                                    },
                                    actionsCellStyle: {
                                        color: currentTheme.secondary,
                                        hover: 'white'
                                    },
                                    rowStyle: rowStyle
                                }}

                                actions={[
                                    rowData => ({
                                        icon: () => (<ChatBubbleOutlineIcon style={{ color: (rowData.Flag || rowData.Lock) ? '#666464' : 'inherit' }} />),
                                        tooltip: 'Manager Comment',
                                        onClick: (event, rowData) => { showManagerComments(rowData); },
                                        hidden: !isManager
                                    }),
                                    rowData => ({
                                        icon: () => (<EditIcon style={{ color: rowData.Flag ? '#666464' : 'inherit' }} />),
                                        tooltip: 'Edit',
                                        onClick: (event, rowData) => { onShowObservationLogAdd(rowData); },
                                        hidden: (rowData.Lock || rowData.Disabled)
                                    }),
                                    rowData => ({
                                        icon: 'edit',
                                        iconProps: { color: (rowData.Lock || rowData.Disabled) ? 'disabled' : 'inherit' },
                                        tooltip: 'Edit',
                                        hidden: (!rowData.Lock && !rowData.Disabled)
                                    })
                                ]}
                            />
                        </Grid>
                    </Grid>
                </>
            }
        </div>
        {(showInactiveMessage) && (
            <InactiveTimeout disContinue={cancel} />
        )}
    </>
    );
});
export default PatientSittingAdd;
